"use client";

import useToastStore from "../../stores/toasts";

import { cn } from "@networx/utils/tailwind/cn";
import Toast from "../Toast";

export default function ToastTray() {
  const toasts = useToastStore((state) => state.toasts);
  const removeToast = useToastStore((state) => state.remove);

  return (
    <div
      className={cn(
        "fixed font-sans right-0 top-3 md:top-16 z-[9999] flex max-w-screen-md flex-col gap-4",
        { "m-4": toasts.length > 0 },
        "lg:top-3",
      )}
    >
      {toasts.map((toast) => (
        <Toast
          key={toast.id}
          variant={toast.variant}
          title={toast.title}
          description={toast.description}
          htmlContent={toast.htmlContent}
          onClose={() => removeToast(toast.id)}
        />
      ))}
    </div>
  );
}
